import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "./translate/i18n";
import "./index.css";

// Título da aba: usa REACT_APP_APP_NAME quando definido no .env; senão mantém o
// padrão estático do index.html ("Numera Studio").
if (process.env.REACT_APP_APP_NAME && process.env.REACT_APP_APP_NAME.trim()) {
  document.title = process.env.REACT_APP_APP_NAME;
}

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
